import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AlertMessageService {
    showSuccess = new BehaviorSubject<any>(null);
    showWarning = new BehaviorSubject<any>(null);
    showInfo = new BehaviorSubject<any>(null);
    showInfoLink = new BehaviorSubject<any>(null);
    successMessages = new BehaviorSubject<any>(null);
    warningMessages = new BehaviorSubject<any>(null);
    infoMessages = new BehaviorSubject<any>(null);
    showHideClose = new BehaviorSubject<boolean>(false);


    displaySuccessMessage(messages?: any, hideSuccess?: boolean) {
        this.showSuccess.next(!hideSuccess);
        this.successMessages.next(messages);
    }

    displayWarningMessage(messages: any) {
        this.showWarning.next(true);
        this.warningMessages.next(messages);
    }

    displayInfoMessage(messages: any, infoLink: any, showHideClose?: any) {
        this.showInfo.next(true);
        this.infoMessages.next(messages);
        this.showInfoLink.next(infoLink);
        this.showHideClose.next(showHideClose);
    }

    public hideSuccess() {
        this.showSuccess.next(false);
    }

    public hideWarning() {
        this.showWarning.next(false);
    }

}
